'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const CLASSNAME = 'CodeMirror-hs-row';
export default class InputRow extends Component {
  render() {
    const _this$props = this.props,
          {
      className,
      children
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    const cx = classNames(CLASSNAME, className);
    return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
      className: cx,
      children: children
    }));
  }

}
InputRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};